var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

import React from 'react';
import Cookies from 'js-cookie';
var XAXIS_THEME = {
  name: 'Xaxis',
  header: {
    backgroundImage: 'linear-gradient(120deg, #57adee 0%, #53b7eb 100%)'
  },
  headerLogo: {
    backgroundImage: 'url(https://xaxis.decidata.tv/themes/xaxis_logo.png)'
  },
  sidebarShortLogo: 'https://xaxis.decidata.tv/themes/xaxis_logo_short.png',
  sidebarFullLogo: 'https://xaxis.decidata.tv/themes/xaxis_logo_color.png'
};
var UMWW_THEME = {
  name: 'UMWW',
  header: {
    backgroundImage: 'linear-gradient(120deg, #ED1D24 0%, #fd2d34 100%)'
  },
  headerLogo: {
    backgroundImage: 'url(https://xaxis.decidata.tv/themes/xaxis_logo.png)'
  },
  sidebarShortLogo: 'https://xaxis.decidata.tv/themes/xaxis_logo_short.png',
  sidebarFullLogo: 'https://xaxis.decidata.tv/themes/xaxis_logo_color.png'
};
var themes = {
  xaxis: XAXIS_THEME,
  umww: UMWW_THEME
};

var withTheme = function withTheme(WrappedComponent) {
  var customTheme = Cookies.get('custom_theme', {
    domain: 'decidata.tv'
  });
  var theme = themes[customTheme];
  return function (props) {
    return React.createElement(WrappedComponent, _extends({
      theme: theme
    }, props));
  };
};

export default withTheme;